import FiltersState from './types'

const initialState: FiltersState = {
    filtersConfigurationResponse: null,
    committedFiltersConfigurationResponse: null,
    error: null,
    isLoading: false,
    isBlocking: false,
    regionNodeId: 0,
    lastDataPathEncoded: '',
    spaMode: false, // we can remove this after map migration
    modalStack: [],
}

export default initialState
